import { MalfunctionTypeEnum } from '../../../backendsdk';

export const MALFUNCTION_PRIORITY_MAP: MalfunctionTypeEnum[][] = [
    [MalfunctionTypeEnum.WrongInstallation, MalfunctionTypeEnum.WrongLicensePlate],
    [MalfunctionTypeEnum.DeviceWellness, MalfunctionTypeEnum.InCabinV1, MalfunctionTypeEnum.FrontFacing],
    [
        MalfunctionTypeEnum.InactiveDevice,
        MalfunctionTypeEnum.SdWellness,
        MalfunctionTypeEnum.MultipleButtonPresses,
        MalfunctionTypeEnum.MultipleImproperShutdownsHw,
        MalfunctionTypeEnum.SystemConstantlyOn,
    ],
    [MalfunctionTypeEnum.PendingInstallation, MalfunctionTypeEnum.PendingRemoval],
];

export const getMalfunctionPriority = (type: MalfunctionTypeEnum): number => {
    return MALFUNCTION_PRIORITY_MAP.findIndex((m) => m.includes(type));
};
